import { ApiService } from "./api.service";
import { PrimeIcons } from "@primevue/core/api";
// import { terminology } from "../helpers/terminology";
export default class PayablesProcessingService extends ApiService {
  namespace = "processing";
  DOMAIN = 140;
  name = "Associate";
  template = "defaultTemplate";
  Width = 900;
  icon = "PaperWithPen";
  action = "action";

  gemItems = [
    {
      key: "uploadFile",
      label: "Upload AP Files",
      icon: "Document",
      services: 176,
      endpoint: "files",
    },
    {
      key: "create",
      label: "To Be Entered",
      icon: "Briefcase",
      services: -63,
    },
    {
      key: "create",
      label: "To Be Paid",
      services: -65,
      icon: "Document",
    },
    {
      key: "listing",
      label: "To Be Approved",
      services: -64,

      icon: "Calendar",
    },
    {
      key: "create",
      label: "Add a Bill",
      icon: "Plus",
      services: 176,
    },
    {
      key: "listing",
      label: "All Bills",
      icon: "Bullets",
      services: 176,
    },
    {
      key: "create",
      label: "Add a Credit",
      icon: "Plus",
      services: 178,
    },
    {
      key: "listing",
      label: "All Credits",
      icon: "Bullets",
      services: 178,
    },
  ];

  constructor() {
    super("processing");
  }
}
